import { FC, useEffect, useState } from 'react';
import { Button, Modal } from 'antd';
import { AiOutlineClose } from 'react-icons/ai';
import { useTranslation } from 'react-i18next';
import Loader from '../../../../../components/Loader';

interface IProps {
  visible: boolean;
  step: 'START' | 'PLAYING' | 'COMPLETE';
  totalCount: number;
  successCount: number;
  failCount: number;

  onCancel(): void;
}

const PaymentProcessModal: FC<IProps> = ({
                                           visible,
                                           step,
                                           totalCount,
                                           successCount,
                                           failCount,
                                           onCancel,
                                         }) => {
  const { t } = useTranslation();

  const [isPaymentFail, setIsPaymentFail] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
  }, []);

  const onLocalCancel = () => {
    isPaymentFail && onCancel();
  };

  const buttonRender = () => {
    switch (step) {
      case 'START':
      case 'PLAYING':
        return (
          <></>
        );
      case 'COMPLETE':
        return (
          <Button key="cancel" className="btn-basic pink" onClick={onCancel}>
            {t('common.button.confirm')}
          </Button>
        );
    }
  };

  const messageRender = () => {
    switch (step) {
      case 'START':
        return (
          <>
            <p>결제 진행 중입니다.</p>
            <p>결제 진행 중에는 카드를 빼지</p>
            <p>마시고 기다려주세요</p>
          </>
        );
      case 'PLAYING':
        return successCount === 0
          ? (
            <>
              <p>결제 진행 중입니다.</p>
              <p>결제 진행 중에는 카드를 빼지</p>
              <p>마시고 기다려주세요</p>
            </>
          )
          : (
          <>
            <p>총 <span>{totalCount}건</span> 중 <span>{successCount < totalCount ? successCount + 1 : totalCount}건</span> 결제
              진행 중입니다.</p>

            <p>결제 진행 중에는 카드를 빼지</p>
            <p>마시고 기다려주세요</p>
          </>
        );
      case 'COMPLETE':
        return (
          <>
            {failCount > 0 ? (
                <>
                  {failCount === totalCount ? (
                    <p>결제에 실패 했습니다.</p>
                  ) : (
                    <>
                      <p>결제가 부분 완료 되었습니다.</p>
                      <p>{totalCount}건 중 {successCount}건 완료 / {failCount}건 실패</p>
                    </>
                  )}
                </>
              )
              :
              (
                <>
                  <p>결제가 완료되었습니다.</p>
                </>
              )}
          </>
        );
    }
  };

  return (
    <>
      {isLoading ? <Loader /> : null}
      <Modal
        title={t('student.student.button18')}
        visible={visible}
        onCancel={onLocalCancel}
        width={600}
        closeIcon={<AiOutlineClose onClick={onLocalCancel} />}
        footer={[
          <div className="comm-btn__area justify-content-center">
            {buttonRender()}
          </div>,
        ]}
      >
        <div className="text-center">
          {messageRender()}
        </div>
      </Modal>
    </>
  );
};

export default PaymentProcessModal;
